import { ListSortDirection, Sort } from "../../models/api/sort";
import { DocumentCategoryDTO, DocumentCategorySTO } from "../../models/document-categories";
import { BaseApiService } from "../base/base-api.service";

export class DocumentCategoriesApiService extends BaseApiService<DocumentCategoryDTO, DocumentCategorySTO> {
  constructor() {
    super({
      servicePath: "/DocumentCategories",
      loadItemsPath: "/GetDocumentCategories",
      saveItemsPath: "/SaveDocumentCategories",
    });
    this.defaultSort = [
      {
        name: "sequence",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadDocumentCategory = async (id?: string) => {
  const response = new DocumentCategoriesApiService().loadItems(
    {
      ids: id ? [id] : [],
    },
    "",
    undefined, // so that the default sort is applied
    undefined // default paging applies
  );

  return response;
};
